/*
 * Accordion
 */
import RooAccordion from './Accordion';
import RooAccordionPanel from './AccordionPanel';
RooAccordion.Panel = RooAccordionPanel;
export * from './interface';
export default RooAccordion;